import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bfae9be0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "abs",
  style: {"z-index":"10"}
}
const _hoisted_2 = ["onClick"]

import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import { useRule } from '@/util/useRules'
import SvgIcon from '@/components/icons/SvgIcon.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['skuList', 'checkSku'],
  emits: ['change', 'close'],
  setup(__props, { emit }) {

const props = __props


const stopFn = (e: any) => {
  e.stopPropapation && e.stopPropapation()
}
const change = (item: any) => {
  emit('change', item.productSku)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "el-zoom-in-top",
    duration: 500
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "mask",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
          })
        ]),
        _createElementVNode("div", {
          class: "product-sku abs",
          onClick: stopFn
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.skuList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass([{active:(item.productSku===props.checkSku)},'product-sku-item']),
              key: index,
              onClick: ($event: any) => (change(item))
            }, _toDisplayString(item.props), 11, _hoisted_2))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})